'use strict';

exports.__esModule = true;
exports.page = undefined;

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _pageActions = require('../actions/page-actions');

var _practicePage = require('../transformers/practice-page');

var _reduxSimpleAuth = require('redux-simple-auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var INITIAL_STATE = {
	practice: {
		practice: {
			attributes: {
				profile_images: [],
				weekday_opening_hours: {
					start: '',
					end: ''
				},
				weekend_opening_hours: {
					start: '',
					end: ''
				}
			},
			address: {
				geolocation: '{"coordinates": []}',
				position: {}
			},
			email: '',
			health_checks: [],
			insurers: [],
			phone: ''
		},
		specialists: []
	},
	profileHeaderData: {
		name: '',
		profileImage: '',
		averageRating: 0,
		totalReviews: 0,
		backgroundImage: '',
		photos: []
	},
	specialists: [],
	practiceAboutSectionExpanded: false,
	payload: {
		firstname: null,
		lastname: null,
		email: null,
		phone: null,
		message: null
	}
};

var LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var getSpecialistsBySpecialty = function getSpecialistsBySpecialty(specialists, selectedSpecialty) {
	return selectedSpecialty && specialists && specialists.filter(function (specialist) {
		return specialist.specialist_specialties.some(function (specialty) {
			return specialty.name === selectedSpecialty;
		});
	}) || specialists;
};

var page = exports.page = function page(state, action) {
	var _Object$assign2, _extends2;

	switch (action.type) {
		case _pageActions.TOGGLE_LIKE + '_RECEIVED':
			return (0, _assign2.default)({}, state, {
				practiceReviews: state.practiceReviews.map(function (review) {
					if (review.id === action.actionData) {
						return (0, _extends4.default)({}, review, {
							likes: action.response.likes || action.response.review.likes
						});
					} else {
						return review;
					}
				})
			});
		case _pageActions.LOAD_PRACTICE_PROFILE + '_RECEIVED':
			return (0, _assign2.default)({}, state, {
				practice: action.response,
				specialists: action.response.specialists
			});
		case _pageActions.LOAD_PRACTICE_PROFILE + '_FAILED':
			return (0, _extends4.default)({}, state, { practiceLoadError: true });
		case _pageActions.TOGGLE_SECTION:
			return (0, _assign2.default)({}, state, (_Object$assign2 = {}, _Object$assign2[action.sectionName + 'SectionExpanded'] = !action.sectionExpanded, _Object$assign2));
		case _pageActions.LOAD_URI:
			return (0, _assign2.default)({}, state, { loadedUri: action.uri });
		case _pageActions.INIT_LOADED:
			return (0, _assign2.default)({}, state, { isInitLoaded: true });
		case _pageActions.UPDATE_SPECIALISTS:
			return (0, _assign2.default)({}, state, {
				specialists: getSpecialistsBySpecialty(state.practice.specialists, action.specialty)
			});
		case _pageActions.BOOK_SELECTED_PACKAGE:
			return (0, _assign2.default)({}, state, {
				selectedPackage: action.packageData,
				showModal: true
			});
		case _pageActions.UPDATE_PAYLOAD:
			return (0, _assign2.default)({}, state, {
				payload: (0, _extends4.default)({}, state.payload, (_extends2 = {}, _extends2[action.property] = action.newValue, _extends2))
			});
		case _pageActions.UPDATE_PROMO_CODE:
			return (0, _assign2.default)({}, state, { promoCode: action.newValue });
		case _pageActions.APPLY_PROMO_CODE:
			// console.log(`Promo code: ${state.promoCode}`);
			// @TODO Validate and apply promo code.
			return (0, _assign2.default)({}, state);
		case _pageActions.SUBMIT_FORM:
			// console.log(state.payload);
			// @TODO Make HTTP request.
			return (0, _assign2.default)({}, state);
		case _pageActions.CLOSE_MODAL:
			return (0, _assign2.default)({}, state, {
				showModal: false,
				payload: {},
				promoCode: null
			});
		case _pageActions.LOAD_PRACTICE_REVIEWS + '_RECEIVED':
			{
				return (0, _assign2.default)({}, state, {
					practiceReviews: (0, _practicePage.transformProfileReviews)(action.response.reviews),
					averageRating: action.response.aggregate_review
				});
			}
		case LOCATION_CHANGE:
			return typeof window === 'undefined' || state.loadedUri && action.payload.pathname && action.payload.pathname.includes(state.loadedUri) ? state : (0, _extends4.default)({}, INITIAL_STATE, { isInitLoaded: true, loadedUri: '' });
		case _reduxSimpleAuth.actionTypes.RESTORE:
		case _reduxSimpleAuth.actionTypes.AUTHENTICATE_SUCCEEDED:
			return (0, _assign2.default)({}, state, {
				payload: (0, _extends4.default)({}, state.payload, {
					patient_id: action.payload.selectedProfile.id
				})
			});
		case _reduxSimpleAuth.actionTypes.INVALIDATE_SESSION:
			return (0, _assign2.default)({}, state, {
				payload: (0, _extends4.default)({}, state.payload, {
					patient_id: null
				})
			});
		default:
			return state || INITIAL_STATE;
	}
};


// WEBPACK FOOTER //
// ./components/practice-page/lib/reducers/page-reducers.js